import React from "react"
import "./Technexdes.css"

function Technexdes() {
  return (
    <div className="Container">
      <div className="heading">
        <h1> TECHNEX</h1>
        <h1> TECHNEX</h1>
      </div>
      <div className="abouttechnex" style={{ marginTop: "-20px" }}>
        <p>
          Welcome to TECHNEX'23, Asia's oldest techno-management festival. We,
          the students of IIT BHU Varanasi, have strived to deliver a
          mesmerizing experience through a simulated virtual world. Take
          advantage of this year's 84th Edition's opportunity to participate in
          a variety of top-notch events. Information regarding all events and
          workshops are now just a few clicks away, so ensure to tread all
          tracks in front of you. It's time to step up your game with Technex!
        </p>
      </div>
    </div>
  )
}
export default Technexdes
